export const loyaltyConfig = {
  loyaltyConfig: "Loyalty Config",
  rate: "Rate",
  bet: "Bet",
  amountPerPoint: "Amount per Point",
  cashPerPoint: "Cash point rate",
  maxRedeemPoint: "Max Redeem point",
  expiry: "Expiry",
  month: "Month",
  activated: "Activated",
  cashrewardEnable: "CashReward Enable",
  save: "Save",
  redeemFortuneWheelLimit: "redeemFortuneWheelLimit",
  fortuneWheelConfig:"Fortune Wheel Config",
  addReward:"เพิ่มของรางวัล",
  name:"ชื่อ",
  reward:"ของรางวัล",
  point:"แต้ม"
};
